<template>
    <div>
        <h3>User Admin</h3>
        <b-input-group prepend="Search Users:">
            <b-input type="text" @input="searchUsersDebounce" placeholder="username@email.com"></b-input>
        </b-input-group>
        <div v-if="users.length <= 0">
            <p class="mt-3">No users found. Try searching for a different username or email.</p>
        </div>
        <b-table v-else :items="users" :fields="userTableFields" :busy="isLoading" selectable @row-selected="onRowSelected">
            <template #cell(actions)="data">
                <b-btn-group>
                    <!-- Reset Email -->
                    <b-btn variant="primary" v-b-tooltip:top="'Send Password Reset Email'" @click="showPasswordModal(data.item)">
                        <font-awesome-icon icon="envelope"/>
                    </b-btn>
                    <!-- View Orders -->
                    <b-btn variant="warning" v-b-tooltip:top="'View Orders'" disabled>
                        <font-awesome-icon icon="shopping-cart"/>
                    </b-btn>
                    <!-- Set Company / Adoption -->
                    <!-- View Company / Adoption -->
                    <b-btn variant="success" v-b-tooltip:top="'View Company / Adoption'" disabled>
                        <font-awesome-icon icon="building"/>
                    </b-btn>
                    <!-- Change Role -->
                    <b-btn variant="danger" v-b-tooltip:top="'Change Role'" disabled>
                        <font-awesome-icon icon="user-cog"/>
                    </b-btn>
                    <!-- Login as -->
                    <b-btn variant="info" v-b-tooltip:top="'Login as User'" @click="showLoginModal(data.item)">
                        <font-awesome-icon icon="sign-in-alt"/>
                    </b-btn>
                </b-btn-group>
            </template>
        </b-table>

        <OrderCollection :orders="selectedUser.orders" v-if="selectedUser.username" />

        <!-- ########################### -->
        <!-- ######### MODALS ########## -->
        <!-- ########################### -->
        <b-modal id="login-as-modal" ok-title="Login" @ok="loginAsUser(selectedUser)">
            <template #modal-header>Login as {{selectedUser.username}}?</template>
            <p>You will be redirected to the home page.</p>
        </b-modal>
        <b-modal id="password-reset-modal" ok-only ok-title="Close">
            <b-input-group prepend="Email">
                <b-input :value="selectedUser.username" readonly></b-input>
            </b-input-group>
            <b-btn @click="sendPasswordReset(selectedUser)" :disabled="resetPasswordOk != null" variant="primary" class="m-2 float-right">Send Email</b-btn>
            <div v-if="resetPasswordResponse">
                <p v-if="resetPasswordOk" class="text-primary">{{resetPasswordResponse}}</p>
                <p v-else class="text-danger">{{resetPasswordResponse}}</p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import OrderCollection from "@/components/dashboard/OrderCollection.vue";

export default {
    name: "UserAdmin",
    components: {OrderCollection},
    data: () => ({
        selectedUser: {},
        users: [],
        isLoading: false,
        searchUsersDebounce: null,

        resetPasswordResponse: "",
        resetPasswordOk: null,
    }),
    computed: {
        userTableFields() {
            return ['username', 'state', 'school_id', 'created_at', 'last_login', 'actions']
        }
    },
    created() {
        this.searchUsersDebounce = _.debounce((value) => {
            this.searchUser(value)
        }, 500)
    },
    methods: {
        async searchUser(searchStr) {
            if (!searchStr || searchStr.length < 3) {
                this.users = [];
                return;
            }

            this.isLoading = true;
            let response = await this.axios.post('user/search', {search_string: searchStr});
            this.users = response.data;
            this.isLoading = false;
        },
        // Forms
        showPasswordModal(user) {
            this.selectedUser = user;
            this.resetPasswordOk = null;
            this.resetPasswordResponse = null;
            this.$bvModal.show('password-reset-modal');
        },
        showLoginModal(user) {
            this.selectedUser = user;
            this.$bvModal.show('login-as-modal');
        },
        // Form Actions
        async sendPasswordReset(user) {
            let response = await this.axios.post('auth/sendResetPassword', {email: user.username});
            if (response.status == 200) {
                this.resetPasswordOk = true;
                this.resetPasswordResponse = response.data.message || "Password reset email sent successfully.";
            } else {
                this.resetPasswordOk = false;
                this.resetPasswordResponse = response.data.message || "An error occurred while sending the password reset email.";
            }
        },
        async loginAsUser(user) {
            this.$auth.impersonate({
                url: 'auth/impersonate/' + user.id,
                redirect: '/'
            });
        },
        onRowSelected(rows) {
            this.selectedUser = rows[0];
        }
    }
}
</script>


<style scoped lang="scss">

</style>